import { paddings } from 'core/styles';
import { typographyDesktop } from 'core/styles/variables';
import styled from 'styled-components';

export const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: ${paddings.tinyPadding};
  font-size: ${typographyDesktop.size.small};
  padding-bottom: 2px;

  .tooltip {
    width: 240px;
    height: 58px;
    padding: ${paddings.defaultPadding};
  }

`;

export const FeedbackAnchor = styled.a`
  display: flex;
  color: ${({ theme }) => theme.colors.onSurface};
  padding-top: ${paddings.tinyPadding};
  gap: ${paddings.tinyPadding};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const TextSpan = styled.span`
  padding-top: 2px;
`;
